export default __webpack_public_path__ + "static/icon-orange-00b59526c948c972fedcc9cd719b07ad.png";